/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component, Fragment } from 'react'
import { ColumnWrapper, BubbleTop, BubbleWrapper, TeamInfo, CircleImage, BigCircle } from './StyledComponents'
import { Icon } from './Icon'
class OurTeamMobileView extends Component {
  state = {
    bigImage: 40,
    medImage: 40,
    smallImage: 35,
    display: false,
    active: '',
    collapse: false,
    mobileView: false
  }
  handleBubbleTop = e => {
    this.setState({ bigImage: 170, smallImage: 170, medImage: 170, display: true, active: e })
  }
  handleTeamInfo = () => {
    this.setState({ display: false, bigImage: 40, medImage: 40, smallImage: 35 })
  }
  render() {
    return (
      <Fragment>
        <BigCircle>
          <ColumnWrapper>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'first'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('first')}>
                <CircleImage imageSize={this.state.active === 'first' && `${this.state.bigImage}px`}>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'first' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.medImage}px`} tx={0} ty={0} active={this.state.active === 'second'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('second')}>
                <CircleImage imageSize={this.state.active === 'second' && `${this.state.medImage}px`}>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'second' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.medImage}px`} tx={0} ty={0} active={this.state.active === 'third'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('third')}>
                <CircleImage imageSize={this.state.active === 'third' && `${this.state.medImage}px`}>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'third' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
          </ColumnWrapper>
          <ColumnWrapper>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'fourth'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('fourth')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'fourth' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'fourth' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.medImage}px`} tx={0} ty={0} active={this.state.active === 'fifth'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('fifth')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'fifth' && this.state.mobileView === true
                      ? `${this.state.medImage}px`
                      : '50px'
                  }>
                  <img src={require('../static/work2.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'fifth' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'sixth'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('sixth')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'sixth' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'sixth' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
          </ColumnWrapper>
          <ColumnWrapper>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'seventh'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('seventh')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'seventh' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'seventh' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'eight'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('eight')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'eight' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'eight' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'nine'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('nine')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'nine' && this.state.mobileView === true ? `${this.state.bigImage}px` : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'nine' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'tenth'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('tenth')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'tenth' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'tenth' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'eleventh'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('eleventh')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'eleventh' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'eleventh' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
            <BubbleTop imageSize={`${this.state.bigImage}px`} tx={0} ty={0} active={this.state.active === 'twelth'}>
              <BubbleWrapper onClick={() => this.handleBubbleTop('twelth')}>
                <CircleImage
                  imageSize={
                    this.state.active === 'twelth' && this.state.mobileView === true
                      ? `${this.state.bigImage}px`
                      : '70px'
                  }>
                  <img src={require('../static/work1.png')} alt="team" />
                </CircleImage>
              </BubbleWrapper>
              <TeamInfo show={this.state.active === 'twelth' && this.state.display}>
                <div onClick={() => this.handleTeamInfo()}>X</div>
                <p>Front-end Developer</p>
                <h4>Saurav</h4>
                <a href="#">
                  <Icon icon="linkedin" />
                </a>
              </TeamInfo>
            </BubbleTop>
          </ColumnWrapper>
        </BigCircle>
      </Fragment>
    )
  }
}
export { OurTeamMobileView }



// WEBPACK FOOTER //
// ./src/components/OurTeamMobileView.js